export default class Random {
    static between(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    };
}